module.exports = __webpack_public_path__ + "static/media/myngle.a4b6bce4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/myngle.webp
// module id = 518
// module chunks = 0